import React, { useContext, useEffect, useState } from "react";
import PageTitle from "../../../jsx/layouts/PageTitle";
import { Button } from "react-bootstrap";
import ReactPaginate from 'react-paginate';


import { UserAccountCountCard } from "./UserAccountCountCard";
import AddAcountManagement from "./AddAccountManagement";
import AccountManagementList from "./AccountManagementList";
import "./style.css";
import { AccountManagementContext } from "../../../context/AccountManagementContext";
import SearchFilter from "../../../jsx/components/SearchFilter/SearchFilter";
import useSearchValue from "../../../hooks/useSearchValue";

const AccountManagement = () => {
    const { showCreateDSO, userAccountList, setShowCreateModal, fetchUserAccountManagementList } = useContext(AccountManagementContext);
    const [perPage, setPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const { searchValue, setSearchValue, debouncedSearchValue, setDebouncedSearchValue } = useSearchValue();
    const handlePageChange = (event) => {
        // Adjusting for zero-based index by adding 1
        const selectedPage = event.selected + 1;
        setCurrentPage(selectedPage);
    };
    useEffect(() => {
        fetchUserAccountManagementList(
            "",
            "desc",
            debouncedSearchValue,
            perPage,
            currentPage
        );
    }, [debouncedSearchValue, perPage, currentPage]);
    useEffect(() => {
        setCurrentPage(1);
    }, [debouncedSearchValue]);
    return (
        <>
            <PageTitle activeMenu="Users" motherMenu="User Management" />
            <UserAccountCountCard />
            <div className="col-12">
                <div className="card">
                    <div className="card-header d-flex justify-content-between">
                        <div>
                            <SearchFilter searchValue={searchValue} setSearchValue={setSearchValue} setCurrentPage={setCurrentPage} />
                        </div>
                        <div>
                            <Button
                                variant="primary"
                                className="mx-2"
                                onClick={() => setShowCreateModal(true)}
                            >
                                Add User <i className="fa fa-plus"></i>
                            </Button>
                            {showCreateDSO && (
                                <AddAcountManagement
                                    debouncedSearchValue={debouncedSearchValue}
                                    perPage={perPage}
                                    currentPage={currentPage}

                                />
                            )}

                        </div>
                    </div>

                    <AccountManagementList setCurrentPage={setCurrentPage} debouncedSearchValue={debouncedSearchValue} perPage={perPage} currentPage={currentPage} />

                </div>
            </div>
            <ReactPaginate
                nextLabel="next >"
                onPageChange={handlePageChange}
                pageRangeDisplayed={8}
                marginPagesDisplayed={5}
                pageCount={Math.ceil(userAccountList?.data?.total / perPage)}
                previousLabel="< previous"
                pageClassName="page-item mx-1 my-1"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link mx-1 my-1"
                nextClassName="page-item mx-1 my-1"
                nextLinkClassName="page-link"
                breakLabel="..."
                breakClassName="page-item mx-1 my-1"
                breakLinkClassName="page-link"
                containerClassName="pagination d-flex flex-wrap"
                activeClassName="active"
                renderOnZeroPageCount={null}
                forcePage={currentPage - 1}
            />
        </>
    );
};

export default AccountManagement;
